import { Link, useLocation } from "react-router-dom";
import { Compass, Ticket, User, LayoutDashboard, CalendarRange, ScanLine, History, ShieldCheck, Users as UsersIcon, Wallet, Settings, Gift, Vote as VoteIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "./Logo";

function NavLink({ to, label, icon, testId }) {
  const loc = useLocation();
  const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
  return (
    <Link to={to} className={`z-bottom-link ${active ? "active" : ""}`} data-testid={testId}>
      {icon}
      <span>{label}</span>
    </Link>
  );
}

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const role = user?.role;

  let nav = null;
  if (!user || role === "buyer") {
    nav = (
      <nav className="z-bottom-nav" data-testid="bottom-nav-buyer">
        <NavLink to="/events" label="Explorer" icon={<Compass />} testId="nav-explore" />
        <NavLink to="/participer" label="Participer" icon={<VoteIcon />} testId="nav-participate" />
        <NavLink to="/tickets" label="Billets" icon={<Ticket />} testId="nav-tickets" />
        <NavLink to="/vouchers" label="Bons" icon={<Gift />} testId="nav-vouchers" />
        <NavLink to="/profile" label="Profil" icon={<User />} testId="nav-profile" />
      </nav>
    );
  } else if (role === "admin") {
    nav = (
      <nav className="z-bottom-nav" data-testid="bottom-nav-admin">
        <NavLink to="/admin" label="Accueil" icon={<LayoutDashboard />} testId="nav-admin-dashboard" />
        <NavLink to="/admin/moderation" label="Modération" icon={<ShieldCheck />} testId="nav-admin-moderation" />
        <NavLink to="/admin/users" label="Utilisateurs" icon={<UsersIcon />} testId="nav-admin-users" />
        <NavLink to="/admin/payouts" label="Paiements" icon={<Wallet />} testId="nav-admin-payouts" />
        <NavLink to="/admin/settings" label="Réglages" icon={<Settings />} testId="nav-admin-settings" />
      </nav>
    );
  } else if (role === "organizer") {
    nav = (
      <nav className="z-bottom-nav" data-testid="bottom-nav-organizer">
        <NavLink to="/org" label="Tableau" icon={<LayoutDashboard />} testId="nav-org-dashboard" />
        <NavLink to="/org/events" label="Événements" icon={<CalendarRange />} testId="nav-org-events" />
        <NavLink to="/org/profile" label="Profil" icon={<User />} testId="nav-org-profile" />
      </nav>
    );
  } else if (role === "agent") {
    nav = (
      <nav className="z-bottom-nav" data-testid="bottom-nav-agent">
        <NavLink to="/agent/scan" label="Scanner" icon={<ScanLine />} testId="nav-agent-scan" />
        <NavLink to="/agent/history" label="Historique" icon={<History />} testId="nav-agent-history" />
      </nav>
    );
  }

  return (
    <>
      <header className="z-header">
        <div className="z-header-inner">
          <Logo to={user ? (role === "agent" ? "/agent/scan" : role === "admin" ? "/admin" : role === "organizer" ? "/org" : "/events") : "/"} />
          {user ? (
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <span style={{ fontSize: 13, color: "var(--z-muted)" }} className="z-header-username">{user.name}</span>
              <button onClick={logout} data-testid="header-logout" className="z-btn z-btn-ghost z-btn-sm">Déconnexion</button>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 8 }}>
              <Link to="/login" data-testid="header-login" className="z-btn z-btn-ghost z-btn-sm">Connexion</Link>
              <Link to="/" data-testid="header-home" className="z-btn z-btn-teal z-btn-sm">Accueil</Link>
            </div>
          )}
        </div>
      </header>
      <main>{children}</main>
      <footer className="z-footer" data-testid="app-footer">
        <div style={{ display: "flex", gap: 14, justifyContent: "center", marginBottom: 6, flexWrap: "wrap" }}>
          <Link to="/cgv" className="z-link" data-testid="footer-cgv-link" style={{ fontSize: 12.5 }}>Conditions Générales</Link>
          <Link to="/confidentialite" className="z-link" data-testid="footer-privacy-link" style={{ fontSize: 12.5 }}>Confidentialité</Link>
        </div>
        <span>Powered by <strong>ALO finances</strong></span>
      </footer>
      {nav}
    </>
  );
}
